import _ from 'lodash'
import { ConnectionType } from '@wix/thunderbolt-becky-types'
import type { ConnectionList as ConnectionListType } from '@wix/thunderbolt-becky-types'
import { DATA_QUERY_TO_COMP_ID_ASPECT } from '../../constants'
import { createTemplateDataNode } from './utils/dataNodeUtils'
import type { DataNodeDependencies } from './types'

export const Connections = createTemplateDataNode<ConnectionListType, DataNodeDependencies, null>({
	getDependencies: (dataItem, scopedCreateRef) =>
		_(dataItem.items)
			.filter(['type', ConnectionType.ConnectionItem])
			.keyBy('controllerId')
			.mapValues((connection) =>
				scopedCreateRef<string>(DATA_QUERY_TO_COMP_ID_ASPECT, _.get(connection, 'controllerId')!)
			)
			.value(),
})
